import { type ExperimentsActivatedBrowserStorageItem } from '../experiments/components/experimentsActivatedBrowserStorage'

import { type UdpTrackingExperimentAssignment } from './model/udpTrackingTypes'

export const udpTrackingBuildExperimentAssignments = (
  activatedExperiments: ExperimentsActivatedBrowserStorageItem[],
): UdpTrackingExperimentAssignment[] => {
  return activatedExperiments.map((experiment) => ({
    name: experiment.name,
    variant: experiment.variant,
  }))
}
